<template>
    <div class="custom-loading" :class="{ simple: simple }" :style="{ background: loadingBackground }">
        <div class="loading">
            <div v-if="simple" class="simple-logo" :style="{ color: loadingTextColor }">
                <svg v-if="!loadingSpinner" class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" fill="none" :style="{ stroke: loadingTextColor }" />
                </svg>
                <i v-else :class="loadingSpinner"></i>
            </div>
            <img v-else-if="loadingCustomImage" :src="loadingCustomImage" class="custom-image" />
            <LoadingLogo v-else></LoadingLogo>
            <div class="text" :class="{ simple: simple }" :style="{ color: loadingTextColor }" v-if="!textless && loadingText">{{ loadingText }}</div>
        </div>
    </div>
</template>
<script>
import LoadingLogo from './loading-logo.vue';
export default {
    name: 'custom-loading',
    components: {
        LoadingLogo
    },
    props: {
        // loading文字
        loadingText: {
            type: String,
            default: '数据加载中，请稍等...'
        },
        // loading文字颜色
        loadingTextColor: {
            type: String
        },
        // 简单模式
        simple: {
            type: Boolean,
            default: false
        },
        // 无文字
        textless: {
            type: Boolean,
            default: false
        },
        // 自定义loading图片
        loadingCustomImage: {
            type: String
        },
        // loading背景颜色
        loadingBackground: {
            type: String
        },
        loadingSpinner: {
            type: String
        }
    },
    data() {
        return {};
    },
    methods: {}
};
</script>
<style lang="scss" scoped>
.custom-loading {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: opacity 0.3s;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    .loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        .simple-logo {
            font-size: 16px !important;
            line-height: 16px !important;
            color: #347fff;
            .circular {
                height: 42px;
                width: 42px;
                animation: loading-rotate 2s linear infinite;
                .path {
                    animation: loading-dash 1.5s ease-in-out infinite;
                    stroke-dasharray: 90, 150;
                    stroke-dashoffset: 0;
                    stroke-width: 2;
                    stroke: #347fff;
                    stroke-linecap: round;
                }
            }
        }
        .custom-image {
            width: 60px;
        }
        .text {
            margin-top: 8px;
            line-height: 1.5em !important;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 14px !important;
            &.simple {
                color: #347fff;
            }
        }
    }
}
@keyframes loading-rotate {
    to {
        transform: rotate(1turn);
    }
}
@keyframes loading-dash {
    0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
    }

    50% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -40px;
    }

    to {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -120px;
    }
}
</style>
<style lang="scss">
.custom-loading-parent-relative {
    position: relative !important;
}
.custom-loading-parent-overflow-hidden {
    overflow: hidden !important;
}
.custom-loading-parent-pointer-events-none {
    pointer-events: none !important;
}
</style>
